const aboutPageSelector = '[data-printale-about-page]';
const aboutStageSelector = '[data-printale-about-stage]';
const aboutSourceSelector = '[data-printale-about-source]';
const aboutCrawlSelector = '[data-printale-about-crawl]';

function normaliseAboutText(text) {
  return text.replace(/\s+/g, ' ').trim();
}

function extractAboutContent(source) {
  const heading = [...source.querySelectorAll('h1, h2, h3')]
    .map((node) => normaliseAboutText(node.innerText || node.textContent || ''))
    .find(Boolean) || 'About Printale';

  const paragraphs = [...source.querySelectorAll('p')]
    .map((node) => normaliseAboutText(node.innerText || node.textContent || ''))
    .filter((paragraph) => paragraph.toLowerCase() !== heading.toLowerCase())
    .filter(Boolean);

  if (paragraphs.length) return { heading, paragraphs };

  const text = normaliseAboutText(source.textContent || '');
  return {
    heading,
    paragraphs: text ? [text] : [],
  };
}

function escapeHtml(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function renderCrawl(crawl, content) {
  // Reverse order: heading last in DOM = bottom of 3D crawl = appears first, close and large.
  // Paragraphs reversed so reading order is correct as text rises from bottom to top.
  const reversedParagraphs = [...content.paragraphs].reverse();
  crawl.innerHTML = `
    ${reversedParagraphs.map((paragraph) => `<p>${escapeHtml(paragraph)}</p>`).join('')}
    <h2>${escapeHtml(content.heading)}</h2>
  `;
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function initScrollProgress(page, stage) {
  let raf = 0;
  let stageHeight = stage.getBoundingClientRect().height;

  function onResize() {
    stageHeight = stage.getBoundingClientRect().height;
    requestUpdate();
  }

  function update() {
    const scrollY = window.scrollY || window.pageYOffset || 0;
    const distance = stageHeight - window.innerHeight;
    const buffer = window.innerHeight * 0.4;
    const animEndRange = Math.max(1, distance - buffer);
    const progress = distance > 0 ? clamp(scrollY / animEndRange, 0, 1) : 0;
    page.style.setProperty('--scroll', progress.toFixed(4));
    raf = 0;
  }

  function requestUpdate() {
    if (!raf) raf = window.requestAnimationFrame(update);
  }

  update();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', onResize, { passive: true });
}

function initPointerGlow(page) {
  if (!window.matchMedia('(hover: hover)').matches) return;

  let lastSpark = 0;

  page.addEventListener('mousemove', (event) => {
    page.style.setProperty('--mx', `${event.clientX}px`);
    page.style.setProperty('--my', `${event.clientY}px`);

    const now = performance.now();
    if (now - lastSpark < 90) return;

    const spark = document.createElement('span');
    spark.className = 'printale-about-spark';
    spark.style.setProperty('--x', `${event.clientX}px`);
    spark.style.setProperty('--y', `${event.clientY}px`);
    spark.style.setProperty('--dx', `${(Math.random() * 70 - 35).toFixed(1)}px`);
    spark.style.setProperty('--dy', `${(Math.random() * 70 - 35).toFixed(1)}px`);
    document.body.appendChild(spark);
    window.setTimeout(() => spark.remove(), 800);
    lastSpark = now;
  }, { passive: true });
}

function initAboutPage(page) {
  const source = page.querySelector(aboutSourceSelector);
  const stage = page.querySelector(aboutStageSelector);
  const crawl = page.querySelector(aboutCrawlSelector);

  if (!source || !stage || !crawl) return;

  const content = extractAboutContent(source);
  if (!content.paragraphs.length) return;

  renderCrawl(crawl, content);
  page.classList.add('is-enhanced');
  document.body.classList.add('printale-about-body');
  initScrollProgress(page, stage);
  initPointerGlow(page);
}

document.querySelectorAll(aboutPageSelector).forEach(initAboutPage);
